import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

/**
 * URL for opening an uploaded file (a paper PDF, a thesis, a job ad, a
 * video file) in the browser.
 *
 * Uses @@display-file rather than @@download so PDFs open inline in the
 * browser tab instead of forcing a save-as dialog. plone.namedfile only
 * honors that for its allowlisted inline mimetypes (PDF among them) and
 * transparently falls back to a normal attachment download for anything
 * else, so this is safe for every file type - including the video files
 * that reuse it.
 *
 * Accepts what the various file fields actually contain: a bare content
 * path ("/papers/ICRA_2016.pdf"), a URL that already carries @@download or
 * @@display-file, or a URL on another host, which is returned unchanged.
 */
export function toDisplayFileUrl(url) {
  if (!url) return url;
  const flat = flattenToAppURL(url);
  // Still absolute after flattening means another host: its file is not a
  // Plone File, and @@display-file would only break the link.
  if (/^[a-z][a-z0-9+.-]*:/i.test(flat)) return flat;
  if (flat.includes('@@display-file') || flat.includes('@@download')) {
    return flat.replace('@@download', '@@display-file');
  }
  return `${flat.replace(/\/$/, '')}/@@display-file/file`;
}

export default toDisplayFileUrl;
